//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { UniversalItemType } from '@models/UniversalItemType';
import angular from 'angular';
import '../styled-link-icon/styled-link-icon';

class LinkIcon {
  public network: string;
  public linkTitle: string;

  public $onInit() {
    let link: string;

    if (this.network && this.network.toLowerCase() !== UniversalItemType.Facebook) {
      link = this.network;
    } else {
      // Default to instagram when no network is passed or network is facebook
      link = UniversalItemType.Instagram;
    }

    this.linkTitle = `This link will take you to ${link}.com`;
  }
}

const template = `<styled-link-icon link-title="$ctrl.linkTitle"></styled-link-icon>`;

angular.module('curalate').component('linkIcon', {
  bindings: {
    network: '<?',
  },
  controller: LinkIcon,
  template,
});
